import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable, of } from "rxjs";

import { Injectable } from "@angular/core";
import { StorageService } from "../services/storage.service";

@Injectable()
export class LoggedInUserGuard implements CanActivate, CanActivateChild {
  constructor(
    private _router: Router,
    private storageService: StorageService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    if (this.storageService.getUser() !== null) {
      return of(true);
    } else {
      this._router.navigate(["/"]);
      return of(false);
    }
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return of(this.storageService.getUser() !== null);
  }
}
